"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const address_1 = __importDefault(require("../../address"));
const carrier_class_1 = __importDefault(require("../carrier.class"));
const carrierIdentifier_1 = __importDefault(require("../carrierIdentifier"));
class RailCarrier extends carrier_class_1.default {
    constructor(id, name, email, phone, ein, address, railwayName, trainNumber, carrierId) {
        super(__1.eTransportMode.RAIL, id, name, email, phone, ein, address, carrierId);
        this.railwayName = railwayName;
        this.trainNumber = trainNumber;
        this.mode = __1.eTransportMode.RAIL;
    }
    update(carrier) {
        super.update(carrier);
        this.railwayName = carrier.railwayName;
        this.trainNumber = carrier.trainNumber;
    }
    static getCarrierId(data) {
        let carrierId = carrierIdentifier_1.default.fromObj(data === null || data === void 0 ? void 0 : data.carrierId);
        if (!carrierId && (data === null || data === void 0 ? void 0 : data.trainNumber)) {
            carrierId = new carrierIdentifier_1.default("trailNumber", data === null || data === void 0 ? void 0 : data.trainNumber);
        }
        return carrierId;
    }
    static fromObj(data) {
        const carrierId = RailCarrier.getCarrierId(data);
        return new RailCarrier(data.id, data.name, data.email, data.phone, data.ein, data.address ? address_1.default.fromObj(data.address) : undefined, data.railwayName, data.trainNumber, carrierId);
    }
    static empty() {
        return new RailCarrier("", "", "");
    }
    validate(path, isPrimary = true) {
        const errors = [];
        errors.push(...super.validate(path, isPrimary));
        return errors;
    }
}
exports.default = RailCarrier;
//# sourceMappingURL=railCarrier.class.js.map